// @flow

const COL_ADDRESS_WIDTH = 400;
const COL_EMAIL_WIDTH = 450;
const COL_PHONE_WIDTH = 200;
const COL_OTHER_WIDTH = 252;
const COL_PROP_WIDTH = 100;
const COL_TAGS_WIDTH = 100;
const COL_ACTION_WIDTH = 245;
const TABLE_MIN_WIDTH = 700;

const styles = {
  colAction: (theme) => ({
    width: COL_ACTION_WIDTH
  }),
  colProps: (theme) => ({
    width: COL_PROP_WIDTH
  }),
  colTags: (theme) => ({
    width: COL_TAGS_WIDTH
  }),
  addressCell: (theme) => ({
    flex: '1 1 auto',
    flexBasis: COL_ADDRESS_WIDTH,
    maxWidth: COL_ADDRESS_WIDTH,
    [theme.breakpoints.down('sm')]: {
      flexBasis: 400,
      maxWidth: 200,
      overflow: 'auto',
      overflowY: 'hidden'
    }
  }),
  emailCell: (theme) => ({
    flex: '1 1 auto',
    flexBasis: COL_EMAIL_WIDTH,
    maxWidth: COL_EMAIL_WIDTH,
    [theme.breakpoints.down('sm')]: {
      // flex: '1 1 auto',
      flexBasis: 350,
      maxWidth:  190,
      overflowX: 'scroll',
      overflowY: 'hidden'
    }
  }),
  phoneCell: (theme) => ({
    flex: '1 1 auto',
    flexBasis: COL_PHONE_WIDTH,
    [theme.breakpoints.down('sm')]:{
      flexBasis: 300,
      maxWidth: 200,
      overflowX: 'scroll',
      overflowY: 'hidden'
    }
  }),
  otherCellHeader: (theme) => ({
    flex: '1 1 auto',
    flexBasis: COL_OTHER_WIDTH,
    maxWidth: COL_OTHER_WIDTH,
    [theme.breakpoints.down('sm')]:{
      flexBasis: 170
    }
  }),
  otherCell: (theme) => ({
    flex: '1 1 auto',
    flexBasis: COL_OTHER_WIDTH,
    maxWidth: COL_OTHER_WIDTH,
    [theme.breakpoints.down('sm')]:{
      flexBasis: 100,
      overflowX: 'scroll',
      overflowY: 'hidden'
    }
  }),
  propertiesCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: COL_PROP_WIDTH,
    maxWidth: COL_PROP_WIDTH
  }),
  tagsCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: COL_TAGS_WIDTH,
    maxWidth: COL_TAGS_WIDTH
  }),
  actionCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: theme.shape.borderRadius,
    paddingRight: 0,
    paddingLeft: 0,
    width: 'auto'
  }),
  simpleMessage: (theme) => ({
    transform: 'translate(7%,18%)'
    
  }),
  staffTableContent: (theme) => ({
    flexGrow: 1,
    paddingTop: 0,
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    width: '100%',
    minWidth: 'auto', // Remove fixed width constraint to prevent overflow
    overflow: 'hidden', // Contain content within viewport
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      minWidth: 0
      // paddingTop is now handled by ContentContainer wrapper
    }
  }),
  customTableStyles: (theme) => ({
    '& .underActionCell': {
      flex: '0 0 auto',
      minWidth: COL_ACTION_WIDTH,
      maxWidth: COL_ACTION_WIDTH,
      paddingRight: 0,
      paddingLeft: 0,
      width: 'auto',
      [theme.breakpoints.down('sm')]:{
        minWidth: '90px'
      }
    },
    '& .hover .underActionCell.oneBtn': {
      flex: '1 1 auto',
      minWidth: COL_ACTION_WIDTH - (theme.layout.listTable.rowHeight * 1),
      maxWidth: COL_ACTION_WIDTH - (theme.layout.listTable.rowHeight * 1),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'auto'
    },
    '& .hover .underActionCell.twoBtn': {
      flex: '1 1 auto',
      minWidth: COL_ACTION_WIDTH - (theme.layout.listTable.rowHeight * 2),
      maxWidth: COL_ACTION_WIDTH - (theme.layout.listTable.rowHeight * 2),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'auto'
    }
  }),
  inlineSpan: (theme) => ({
    marginLeft: theme.spacing(1),
    position: 'relative',
    top: 2
  }),
  inlineBtn: (theme) => ({
    padding: 0,
    marginLeft: theme.spacing(1)
  }),
  callForwardSettings: (theme) => ({
    paddingTop: 0,
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2.5),
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    }
  }),
  staffCount: (theme) => ({
    color: theme.palette.custom.backgroundTextInfo,
    fontSize: '0.8rem'
  })
};

export default styles;